import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import withPageComponents from '../../../page/components/with-page-components';
import usePage from '../../../hooks/usePage';
import ETRWCSApi from '../../../core/src/etr-wcs-api-client';

/***
 * Componentent watchs for selection changes and updates page SEO meta tags
 * @param sortedSKUs
 * @param verifyingPicks
 * @returns {JSX.Element}
 */
const SEOMEtaUpdate = React.memo(({ sortedSKUs, verifyingPicks, vanityUrl, canonical }) => {
    const { updateSeo } = usePage();
    const [initialList, setInitialList] = useState();
    const [hasChanged, setHasChanged] = useState(false);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        if (sortedSKUs && !initialList) {
            setInitialList(sortedSKUs);
        } else if (initialList && !hasChanged && sortedSKUs !== initialList) {
            setHasChanged(true);
        }
    }, [sortedSKUs, initialList]);

    useEffect(() => {
        if (!verifyingPicks && sortedSKUs && hasChanged) {
            const componentKey = 'configure';
            const path = `${componentKey}/${vanityUrl}&skus=${sortedSKUs}`;
            ETRWCSApi.seo.get('configure', path).then(resp => {
                try {
                    updateSeo(resp, (state, seo) => {
                        const { seo: currentSEO } = state;
                        return { ...state, seo: { ...currentSEO, ...seo } };
                    });
                } catch (e) {}
            });
        }
    }, [verifyingPicks, sortedSKUs, hasChanged]);

    useEffect(() => {
        if (canonical) {
            const { pathname } = location || {};
            const isCustom = pathname.includes('custom');
            const [basename, path] = pathname.split('custom/');
            const [canonicalBase, pathAndQuery] = canonical.split('custom/');
            const [nextPath, query] = pathAndQuery.split('?');
            const newPath = `${basename}custom/${nextPath}`.replace('/custom/custom', '/custom');
            if (isCustom && path !== nextPath && nextPath.indexOf('all-configurations') === -1) {
                history.replace(`${newPath}${query ? `?${query}` : ''}`, { ...location, search: query });
            }
        }
    }, [canonical]);

    return null;
});

export default withPageComponents(
    ({ componentList, verifyingPicks, vanityUrl, seo }) => {
        const [dir] = vanityUrl?.split('/') || [];
        const canonical = seo?.canonical;
        return dir === 'custom' ? (
            <SEOMEtaUpdate
                sortedSKUs={componentList?.join(',')}
                verifyingPicks={verifyingPicks}
                vanityUrl={vanityUrl}
                canonical={canonical}
            />
        ) : null;
    },
    { components: ['componentList', 'verifyingPicks'], seo: true }
);
